/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Double_Pumps_Permutation_NoteInputs */

const fr_double_pumps_permutation_note = /** @type {((inputs: Double_Pumps_Permutation_NoteInputs) => LocalizedString) & { parts: (inputs: Double_Pumps_Permutation_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Double_Pumps_Permutation_NoteInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Note: Lorsque la permutation des chaudières est en auto, la permutation des pompes doubles
s’effectue au même moment (Voir )`)
		}),
		{
			parts: /** @type {(inputs: Double_Pumps_Permutation_NoteInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Note: Lorsque la permutation des chaudières est en auto, la permutation des pompes doubles\ns’effectue au même moment (Voir " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: ")" }])
			})
		}
	)
);

const en_double_pumps_permutation_note = /** @type {((inputs: Double_Pumps_Permutation_NoteInputs) => LocalizedString) & { parts: (inputs: Double_Pumps_Permutation_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Double_Pumps_Permutation_NoteInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Note: When boiler changeover is set to auto, double pumps
are changed over at the same time (see ).`)
		}),
		{
			parts: /** @type {(inputs: Double_Pumps_Permutation_NoteInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Note: When boiler changeover is set to auto, double pumps\nare changed over at the same time (see " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: ")." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Note: When boiler changeover is set to auto, double pumps are changed over at the same time (see )." |
*
* @param {Double_Pumps_Permutation_NoteInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const double_pumps_permutation_note = /** @type {((inputs?: Double_Pumps_Permutation_NoteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs?: Double_Pumps_Permutation_NoteInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Double_Pumps_Permutation_NoteInputs, { locale?: "fr" | "en" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Double_Pumps_Permutation_NoteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_double_pumps_permutation_note(inputs)
			return fr_double_pumps_permutation_note(inputs)
		}),
		{
			parts: /** @type {(inputs?: Double_Pumps_Permutation_NoteInputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Double_Pumps_Permutation_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (en_double_pumps_permutation_note).parts?.(inputs) ?? [{ type: "text", value: en_double_pumps_permutation_note(inputs) }]
				return /** @type {{ parts?: (inputs: Double_Pumps_Permutation_NoteInputs) => import('../runtime.js').MessagePart[] }} */ (fr_double_pumps_permutation_note).parts?.(inputs) ?? [{ type: "text", value: fr_double_pumps_permutation_note(inputs) }]
			})
		}
	)
);